import { mockFields, mockGroups, mockSignups, mockFunds, mockUsers } from "./mockHelperFunctions";

const initialMockSettingsData = {
  networkFamilyRegistration: {
    enabled: true,
    networkName: "Mock Network Name",
    registrationUrl: "https://mockdata.flocknote.com/mock",
  },
  introductionMessage: {
    enabled: true,
    message: "Hello, this is a mock introduction message.",
  },
  accentColor: {
    enabled: true,
    selectedColor: "#278DC1",
    availableColors: ["#278DC1", "#278DC1", "#278DC1"],
  },
  membershipStatuses: {
    enabled: true,
    statuses: [
      {
        enabled: true,
        membershipStatusID: 1,
        description: "Registered Member",
        order: 1,
        canEditDescription: true,
        canReorder: false,
        canDelete: false,
      },
      {
        enabled: true,
        membershipStatusID: 2,
        description: "Visitor",
        order: 2,
        canEditDescription: true,
        canReorder: true,
        canDelete: true,
      },
      {
        enabled: false,
        membershipStatusID: 3,
        description: "Consultant",
        order: 3,
        canEditDescription: true,
        canReorder: true,
        canDelete: true,
      },
      {
        enabled: false,
        membershipStatusID: 4,
        description: "Casual Attender",
        order: 4,
        canEditDescription: true,
        canReorder: true,
        canDelete: true,
      },
      {
        enabled: false,
        membershipStatusID: 5,
        description: "Deceased",
        order: 5,
        canEditDescription: false,
        canReorder: false,
        canDelete: false,
      },
    ],
  },
  extendedFieldsAdults: {
    enabled: true,
    fields: mockFields(),
    // welcomeMessage: {},
  },
  registrationGroupAdults: {
    enabled: true,
    selectedGroupID: 2,
    availableGroups: mockGroups(),
  },
  extendedFieldsChildren: {
    enabled: true,
    fields: mockFields(),
    // welcomeMessage: {},
  },
  registrationGroupChildren: {
    enabled: true,
    selectedGroupID: 3,
    availableGroups: mockGroups(),
  },
  recurringGifts: {
    enabled: true,
    selectedFundID: 1,
    availableFunds: mockFunds(),
  },
  receiveGivingEnvelopes: {
    enabled: false,
  },
  closingMessage: {
    enabled: true,
    message: "This is my mock closing message... pretty good, eh?",
  },
  finishedActionSettings: {
    enabled: true,
    closingMessageOnly: {
      enabled: true,
    },
    goToSignup: {
      enabled: false,
      selectedSignupID: 1,
      availableSignups: mockSignups(),
    },
    goToWebsite: {
      enabled: false,
      websiteUrl: "http://eelslap.com/",
    },
  },
  finishedActionClosing: { enabled: true },
  finishedActionSignup: {
    enabled: false,
    selectedSignupID: 1,
    availableSignups: mockSignups(),
  },
  finishedActionWebsite: {
    enabled: false,
    websiteUrl: "http://eelslap.com/",
  },
  completionNote: {
    enabled: false,
    selectedUserID: 1,
    availableUsers: mockUsers(),
  },
};

export default initialMockSettingsData;